import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {ascSort, indexNotFound, isDefined, utf8Decode} from "sdv-common";
import {Folder} from "../model/folder.model";
import {Attribute} from "../model/attribute.model";
import {retryAfterMillis} from "../shared/constants";

@Injectable({providedIn: 'root'})
export class FolderService {

  private folders: Folder[] = [
    {
      id: 'all',
      name: 'folder.all',
      icon: null,
      priority: -999,
      system: true,
      attributes: []
    },
    {
      id: 'new',
      name: 'folder.new',
      icon: null,
      priority: -1,
      system: true,
      attributes: []
    }
  ];

  public passwordAttrId = 1;
  public colorAttrId = 2;
  public pinnedttrId = 3;
  public iconAttrId = 4;
  public favoriteAttrId = 5;

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('folders')
      .subscribe(response => {
        let folders: Folder[] = [];
        for (const folder of response) {
          folders.push(this.covertFolder(folder));
        }
        this.folders = this.folders.concat(folders);
        ascSort(this.folders, 'priority');
      }, err => {
        this.apiService.error({}, err);
        setTimeout(() => this.load(), retryAfterMillis);
      });
  }

  private covertFolder(folder) {
    return {
      id: utf8Decode(folder.id),
      name: utf8Decode(folder.name),
      icon: folder.icon ? utf8Decode(folder.icon) : 'folder',
      priority: folder.priority,
      system: folder.system,
      attributes: (folder.attributes || []).map(n => ({
        created: n.createdMillis || 0,
        id: utf8Decode(n.id || ''),
        value: n.value,
        code: n.code
      }))
    };
  }

  add($e, folder) {
    this.apiService.post("folders", {
      name: folder.name
    }).subscribe(folder => {
      this.folders.push(this.covertFolder(folder));
      $e.target.parentNode.querySelector('[data-bs-dismiss]')
        .dispatchEvent(new Event('click'));
    }, err => {
      this.apiService.error(folder, err);
    });
  }

  attrCreate(folder, attrId, value) {
    this.apiService.post('folders/' + folder.id + '/attributes', {
      typeId: attrId,
      value
    })
      .subscribe(response => {
        folder.attributes.push({
          created: response.createdMillis,
          id: utf8Decode(response.id),
          value: response.value,
          code: response.code
        });
      }, err => {
        this.apiService.error(folder, err);
      });
  }

  getAttribute(attributes: Attribute[], search) {
    return attributes.find(n => n.code === search);
  }

  getAttributeValue(attributes: Attribute[], search, def: any = undefined) {
    const attribute = this.getAttribute(attributes, search);
    return isDefined(attribute) ? attribute.value : def;
  }

  attrDelete(folder, attrId) {
    return new Promise((resolve, reject) => {
      this.apiService.delete('folders/' + folder.id + '/attributes/' + attrId)
        .subscribe(() => {
          let dealIndex = indexNotFound;
          for (let i = 0; i < folder.attributes.length; i++) {
            if (folder.attributes[i].id === attrId) {
              dealIndex = i;
              break;
            }
          }
          if (dealIndex != indexNotFound) {
            folder.attributes.splice(dealIndex, 1);
          }
          resolve({});
        }, err => {
          this.apiService.error(folder, err);
          reject(err);
        });
    });
  }

  getFolders(parentId = 'all') {
    let items = this.folders;
    if (parentId && parentId != 'all') {
      items = items.filter(n => n.parent_id === parentId);
    }
    return items;
  }

  remove(id: any) {
    this.apiService.delete("folders/" + id).subscribe(() => {
      let index = this.folders.findIndex(folder => folder.id === id);
      this.folders.splice(index, 1);
    }, err => {
      this.apiService.error({}, err);
    });
  }
}
